import React, { createContext, useCallback, useMemo, useState } from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';

export const NotificationContext = createContext({
  notify: () => {},
});

const Alert = (props) => {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
};

export const NotificationProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [severity, setSeverity] = useState('info'); // 'success' | 'info' | 'warning' | 'error'
  const [autoHideDuration, setAutoHideDuration] = useState(4000);

  const handleClose = (_, reason) => {
    if (reason === 'clickaway') return;
    setOpen(false);
  };

  const notify = useCallback((msg, options = {}) => {
    const { severity: sev = 'info', duration = 4000 } = options;
    setMessage(msg);
    setSeverity(sev);
    setAutoHideDuration(duration);
    setOpen(true);
  }, []);

  const value = useMemo(() => ({ notify }), [notify]);

  return (
    <NotificationContext.Provider value={value}>
      {children}
      <Snackbar
        open={open}
        autoHideDuration={autoHideDuration}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert onClose={handleClose} severity={severity}>
          {message}
        </Alert>
      </Snackbar>
    </NotificationContext.Provider>
  );
};
